<template>
<div>
<ContentOverlay ></ContentOverlay>

<div class="content_card" v-if="item">





<div class="grid">






<div class="col-12 md:col-12">
<div class="content_card_content">

<TabNavigation :tabs="tabs"></TabNavigation>
<router-view></router-view>

</div>
</div>

</div>




</div>
 </div> 
</template>

<script>
export default {

  name: 'SupplierBrandDetail',

  data () {
    return {
    	item:null,
    	tabs: [
      /*
          {
              title: 'durum',
              icon: 'chart-line',
              route:'info'
          },
          */
          {
              title: 'marka',
              icon: 'list',
              route:'brand'
          },
          
          {
              title: 'projeler',
              icon: 'calendar',
              route:'projects'
          },
      ],
    }	
  },
  mounted()
  {
    
    this.getData()
  },
  methods:{
	async getData()
	{
		this.item = "test"
	}
  },
}
</script>

<style lang="css" scoped>
</style>